import { render, staticRenderFns } from "./UserTaskRecord.vue?vue&type=template&id=293252f6"
import script from "./UserTaskRecord.vue?vue&type=script&lang=ts"
export * from "./UserTaskRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports